var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88889 2.00049C2.39822 2.00049 2 2.39871 2 2.88938C2 3.38004 2.39822 3.77827 2.88889 3.77827L7.42361 10.8894H12.6111L17.1111 3.77827C17.6018 3.77827 18 3.38004 18 2.88938C18 2.39871 17.6018 2.00049 17.1111 2.00049H2.88889ZM8.22222 12.6672V17.1116C8.22222 17.6023 8.62044 18.0005 9.11111 18.0005H10.8889C11.3796 18.0005 11.7778 17.6023 11.7778 17.1116V12.6672H8.22222Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.50fbd6d24052015c050cc6824b2ae548.svg";
export { ForwardRef as ReactComponent };